import axios from "axios";

/**
 * Fetch data from the API and update state in the parent component.
 *
 * @param {string} pageName - The API endpoint page name (e.g., "juniorTeen").
 * @param {Function} setData - State setter function to update the data.
 * @param {Function} setLoading - State setter function to update the loading state.
 *
 * @example
 * fetchData("juniorTeen", setData, setLoading);
 */
export function fetchData(pageName, setData, setLoading) {
    const API_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/"
        : "https://api.hillerodfrimenighed.dk/";

    async function getData() {
        setLoading(true); // Start loading
        try {
            const response = await axios.get(`${API_URL}${pageName}`);
            setData(response.data); // Axios automatically parses JSON
        } catch (error) {
            console.error("Error fetching data:", error);
            setData(null); // Ensure data is reset if an error occurs
        } finally {
            setLoading(false); // Stop loading
        }
    }

    getData(); // Call the function immediately
}
